'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function maybeFormatMessage(intl, keyPrefix, keySuffix, values) {
  var intlKey = keySuffix ? [keyPrefix, keySuffix].join('.') : keyPrefix;
  return intl.messages[intlKey] ? intl.formatMessage({
    id: intlKey
  }, values) : null;
}

exports.default = maybeFormatMessage;
//# sourceMappingURL=maybeFormatMessage.js.map
